import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { IconSize, IconSortAscending, IconSortDescending, IconSort } from "../../icons";
import { EventKeys } from "../../utils";
import { SortDirection } from "../interfaces";
import { TABLE_HEADER_BUTTON_SORT_ICON_COLOR } from "./constants";
import { TableHeaderButtonBase, TableHeaderButtonContent } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";

var TableHeaderButton = function TableHeaderButton(_ref) {
  var children = _ref.children,
      justifyContent = _ref.justifyContent,
      onClick = _ref.onClick,
      sortDirection = _ref.sortDirection,
      spacing = _ref.spacing,
      titleText = _ref.titleText,
      textAlign = _ref.textAlign;

  // Be used to indicate if button is focused by tab press.
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocusedByTab = _useState2[0],
      setIsFocusedByTab = _useState2[1];

  var SortingIcon;

  if (sortDirection === SortDirection.Ascending) {
    SortingIcon = IconSortAscending;
  } else if (sortDirection === SortDirection.Descending) {
    SortingIcon = IconSortDescending;
  } else {
    SortingIcon = IconSort;
  }

  var handleKeyUp = function handleKeyUp(e) {
    if (e.key === EventKeys.TAB) {
      setIsFocusedByTab(true);
    }
  };

  var handleBlur = function handleBlur() {
    setIsFocusedByTab(false);
  };

  return ___EmotionJSX(TableHeaderButtonBase, {
    title: titleText,
    onClick: onClick,
    isFocusedByTab: isFocusedByTab,
    onKeyUp: handleKeyUp,
    onBlur: handleBlur
  }, ___EmotionJSX(TableHeaderButtonContent, {
    spacing: spacing,
    alignItems: "center",
    justifyContent: justifyContent,
    textAlign: textAlign,
    gridGap: "S100"
  }, !!children && children, ___EmotionJSX(SortingIcon, {
    "aria-hidden": true,
    color: TABLE_HEADER_BUTTON_SORT_ICON_COLOR,
    size: IconSize.ExtraSmall
  })));
};

export default TableHeaderButton;